<div style="background:white;">
  <div class="comment-header">
    <label>Comments</label>
    <button (click)="headerData.toggleCommentPanel(false, null)" class="close-panel" id="close-comments-button">
      <mat-icon class="search-clear"> clear      </mat-icon>
    </button>
  </div>

  @if (tileData) {
    <div [ngClass]="{'tile-dtp': button_class === true}" class="comment-drawer">
      <div [ngClass]="{'no-dtp': tileData.show_comment_dtp===false}">
        <div class="comment-align">
          <h3 class="h3-inline">New Comment: </h3>
          <div>
            @if (tileData.tileTitle) {
              <label>{{tileData.title}}</label>
            }
            @if (!tileData.tileTitle) {
              <label>{{tile.content}}</label>
            }
            <textarea (keyup)="textAreaAdjust($event)" [(ngModel)]="newComment" appMention
              id="comment_area" placeholder="Type to add a comment. Type @ to mention someone."
              rows="2"
              style="overflow:hidden" tabindex="0">
            </textarea>
          </div>
          <button (click)="saveComment()" class="btn-save-comment"></button>
        </div>
        <div class="action-buttons">
          <button (click)="saveComment()" class="btn-save">Submit Comment</button>
        </div>
        <div class="comment-info">
          @if (tileData.comment) {
            @if (tileData.comment.series) {
              <label class="row"><b>Series:</b> {{tileData.comment.series.attributes | nameOrDescription}}</label>
            }
            @if (tileData.comment.session_state) {
              <label class="row"><b>Page:</b> {{tileData.comment.session_state.attributes | nameOrDescription}}</label>
            }
            @if (tileData.comment.start) {
              <label class="row"><b>Time: </b>{{tileData.comment.start  | stringDate}}
            - {{tileData.comment.end  | stringDate}}</label>
          }
        }
      </div>
      @if (tileData.show_comment_dtp !== false && show_dtp !== false) {
        <date-time-period
          [immutable]="true" [no_url]="true"
          [showTimespan]="false"
        class="date-period wrap comment-dtp"></date-time-period>
      }
    </div>
    <div class="comment-list-container">
      <!--    @if (tileData && tileData.events) { <label>Comments for {{tileData.tileTitle ? tileData.title : tile.content}}</label> }-->
      <ul class="comment-list">
        @for (event of tileData.events; track event) {
          <li (mouseenter)="commentHover(event, tileData.events.indexOf(event))"
            (mouseleave)="commentLeave(event, tileData.events.indexOf(event))"
            >
            <div [ngClass]="{'shadow': hovering_events.includes(event?.id)}" class="comment-inner">
              <div class="comment-by">{{event.attributes.created_by_name}}</div>
              <div class="comment-on">{{event.attributes.changed_on | stringDate}}</div>
              <div class="comment-text">{{event.attributes.comment}}</div>
              @if (event.attributes.series_names && event.attributes.series_names.length> 0) {
                <div
                  class="series-list comment-list-series">
                  Applies to:
                  <ul>
                    @for (series of event.attributes.series_names; track $index) {
                      <li [matTooltip]="series">{{series}}</li>
                    }
                  </ul>
                </div>
              }
              <div class="comment-period">
                {{event.attributes.start | stringDate}}
                - {{event.attributes.end | stringDate}}
              </div>
            </div>
          </li>
        }
      </ul>
      @if (series && series.relationships.event_constant_collation_series_export?.data && dateInst.dtp) {
        <label class="comment-info" style="padding:10px 0 0 0;border-top: 2px ridge;">Series Collation Events</label>
        @if (tileDtp) {
          <constant-property-events [series]="series"
            [dtp]="tileDtp">
          </constant-property-events>
        }
      }
    </div>
  </div>
}
</div>

<at-who [ngStyle]="{'display': appScope.at_who===true? 'block': 'none'}" class="at-who-container"
  id="at_who">
</at-who>
